import { useEffect, useRef, useState } from 'react';
import { animate, useReducedMotion } from 'motion/react';

/**
 * A number that counts to its new value instead of jumping — for counts
 * that change as the seller filters. Renders the plain value when the
 * viewer prefers reduced motion.
 */
export function NumberTicker({
  value,
  duration = 0.9,
  className,
}: {
  value: number;
  /** Seconds for the count. */
  duration?: number;
  className?: string;
}) {
  const reduced = useReducedMotion();
  const [shown, setShown] = useState(value);
  const previous = useRef(value);

  useEffect(() => {
    if (reduced || previous.current === value) {
      previous.current = value;
      setShown(value);
      return;
    }
    const controls = animate(previous.current, value, {
      duration,
      ease: 'easeOut',
      onUpdate: (latest) => setShown(Math.round(latest)),
    });
    previous.current = value;
    return () => controls.stop();
  }, [value, duration, reduced]);

  return <span className={className}>{shown}</span>;
}
